import { useTranslation } from 'react-i18next'

import {
  ENTITY_PROFILE_EDIT_INPUT_MIN_ROWS,
  ENTITY_PROFILE_INPUT_MAX_LENGTH,
} from '../../Entity'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { TextareaOutlineField } from '../../Textarea'
import { DOC_FLOW_FORM_FIELD_TITLE } from '../DocFlow.constants'

function DocFlowProfileHeaderEditTitleField(props) {
  const { t } = useTranslation()

  return (
    <FormikField
      {...props}
      autoFocus
      clearable
      required
      withoutManualResize
      Component={TextareaOutlineField}
      getErrorProps={getFormikFormFieldErrorProps}
      label={t('DocumentStapling.ModalEditTitleProfileLabelKey')}
      maxLength={ENTITY_PROFILE_INPUT_MAX_LENGTH}
      minRows={ENTITY_PROFILE_EDIT_INPUT_MIN_ROWS}
      name={DOC_FLOW_FORM_FIELD_TITLE}
      placeholder={t('DocumentStapling.ModalEditTitleProfilePlaceholderKey')}
    />
  )
}

export default DocFlowProfileHeaderEditTitleField
